export default __webpack_public_path__ + "static/media/conversation.51889fef.svg";